import React from 'react';
import { Table } from 'flowbite-react';
import { Change } from '../../models';
import { ChangeModal } from '..';
import { loadChange, resetChanges, useAppDispatch, useAppSelector } from '../../redux';
import { ChangeListHead, ChangeListRow } from './ChangeListRow';

interface ChangesListProps {
    changes: Change[];
    withHeader?: boolean;
    hideUser?: boolean;
    hideStatut?: boolean;
}

function ChangesList(props: ChangesListProps) {
    const dispatch = useAppDispatch();
    const { changes, withHeader, hideUser, hideStatut } = props;
    const [currentChangeId, setCurrentChangeId] = React.useState<string | undefined>();

    const { user }   = useAppSelector(state => state.auth);
    const { active } = useAppSelector(state => state.tracks);
    const { change } = useAppSelector(state => state.changes);

    const projectsMap: Record<string, boolean> = {};

    const projectsIds = Object.keys(projectsMap);

    const selectChange = ((change?: Change) => {
        setCurrentChangeId(change?._id);
        if (change)
            dispatch(loadChange(change._id));
        else
            dispatch(resetChanges(/*onlyItem*/true));
    });

    return (
        <main className="h-full w-full">
            <Table striped hoverable className="w-full max-w-[calc(100vw-2rem)] table-fixed border rounded">
                {withHeader && (
                    <ChangeListHead
                        hideUser={hideUser}
                        hideStatut={hideStatut}
                        projectsIds={projectsIds}
                    />
                )}
                <Table.Body>
                    {changes.map((c: Change) => (
                        <ChangeListRow
                            key={c._id}
                            change={c}
                            hideUser={hideUser}
                            hideStatut={hideStatut}
                            projectsIds={projectsIds}
                            user={user}
                            active={active}
                            onSelectChange={selectChange}
                        />
                    ))}
                </Table.Body>
            </Table>
            {change && change._id === currentChangeId && change.project?.name && (
                <ChangeModal
                    project={change.project}
                    change={change}
                    show={true}
                    showProjectName={true}
                    onClose={() => selectChange()}
                    onRemove={(values: AnyObj) => { }}
                />
            )}
        </main>
    );
};

export default ChangesList;
